import { z } from "zod";

import { BlankDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";

export const blankTypeDisplay: Record<BlankDocumentType, string> = {
  [BlankDocumentType.BLANK]: "Blank",
};

export const blankSchema = z.object({});

export type Blank = z.infer<typeof blankSchema> & DatabaseDefaults;

export const blankShape: Blank = {
  id: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
